export const industryToSquarespaceMap: Map<string, string> = new Map([
    ['accounting', 'ACCOUNTING_AND_FINANCIAL'],
    ['art', 'ART_AND_DESIGN'],
    ['cosmetics', 'BEAUTY_AND_PERSONAL_CARE'],
    ['spa', 'BEAUTY_AND_PERSONAL_CARE'],
    ['community', 'COMMUNITY_AND_NONPROFIT'],
    ['entertainment', 'ENTERTAINMENT_AND_MEDIA'],
    ['fashion', 'FASHION'],
    ['food', 'FOOD_AND_DRINK'],
    ['physical', 'HEALTH_AND_FITNESS'],
    ['sports', 'HEALTH_AND_FITNESS'],
    ['home', 'HOME_AND_LIVING'],
    ['architecture', 'HOME_AND_LIVING'],
    ['landscaping', 'HOME_AND_LIVING'],
    ['attorney', 'LEGAL_SERVICES_AND_ATTORNEYS'],
    ['communications', 'MARKETING_AND_ADVERTISING'],
    ['business', 'MARKETING_AND_ADVERTISING'],
    ['photography', 'PHOTOGRAPHY'],
    ['realestate', 'REAL_ESTATE'],
    ['retail', 'RETAIL_RESTAURANT_AND_BAR'],
    ['restaurant', 'RETAIL_RESTAURANT_AND_BAR'],
    ['bar', 'RETAIL_RESTAURANT_AND_BAR'],
    ['technology', 'TECHNOLOGY'],
    ['internet', 'TECHNOLOGY'],
    ['travel', 'TRAVEL_AND_LIFESTYLE'],
    ['wedding', 'WEDDING'],
]);
